/**
 * Builds a clean query-param object for axios, dropping undefined/null/''
 * values so filters are only sent when actually set (the backend treats an
 * absent key differently from an empty string for enum/uuid parsing).
 */
export function cleanParams(params: object): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params as Record<string, unknown>)) {
    if (value === undefined || value === null || value === '') continue;
    out[key] = value;
  }
  return out;
}
